import React from "react";

function NoGroupPresentPopup({ setGroupNotPresentPopUp }) {
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div className="d-flex justify-content-center align-items-center">
          <img src="/images/alert.svg" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg20">
          Oops!! Query is Not Enabled by Teacher for this Subject. Please
          Contact your Subject Teacher.{" "}
        </div>
        <div className="d-flex justify-content-around align-items-center mt-3 widthOfContainer">
          <button
            className="okayBtnsucess"
            onClick={() => setGroupNotPresentPopUp(false)}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}

export default NoGroupPresentPopup;
